import { HttpClient, HttpEvent, HttpHeaders, HttpParameterCodec, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Configuration } from '@app/common/configuration';
import { apiResponseFormat } from '@app/common/variables';
@Injectable({ providedIn: 'root' })
export class EnvironmentService {


  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;
  authServerUrl = environment.API_APP_PATH;

  constructor(private readonly http: HttpClient,) {

  }

  /**
   * Returns an observable of all environments.
   */
  public getEnvironments(
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: apiResponseFormat;
    }
  ): Observable<any>;
  public getEnvironments(
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: apiResponseFormat;
    }
  ): Observable<HttpResponse<any>>;
  public getEnvironments(
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: apiResponseFormat;
    }
  ): Observable<HttpEvent<any>>;
  getEnvironments(
    observe: any = "body",
    reportProgress = false,
    options?: {
      httpHeaderAccept?: apiResponseFormat;
    }
  ): Observable<any> {
    let headers = this.defaultHeaders;

    let httpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected?.startsWith("text")
    ) {
      responseType = "text";
    }
    return this.http.get<any>(
      `${this.authServerUrl}/api/app/environment/environments`,
      {
        responseType: responseType as any,
        withCredentials: false,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Adds a new environment to the mock list and updates mapped services.
   * @param environment The environment object to add
   */
addEnvironment(environment: any): Observable<any> {
    // Call backend API to create environment
    const url = `${this.authServerUrl}/api/app/environment/create-environment`;
    return this.http.post<any>(url, environment, {
      headers: this.defaultHeaders.set('Content-Type', 'application/json'),
      withCredentials: false
    });
  }
  /**
    * Updates an existing environment and its mapped services.
    * @param environment The updated environment object
    */
  updateEnvironment(environment: any): Observable<{ message: string }> {
    // Call backend API to update environment
    const url = `${this.authServerUrl}/api/app/environment/update-environment`;
    return this.http.post<{ message: string }>(url, environment, {
      headers: this.defaultHeaders.set('Content-Type', 'application/json'),
      withCredentials: false
    });
  }

  /**
   * Returns an observable of mapped services for a given environment by id from backend API.
   * @param environmentId The id (GUID) of the environment
   */
  public getMappedServices(
    environmentId: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: apiResponseFormat;
    }
  ): Observable<any>;
  public getMappedServices(
    environmentId: string,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: apiResponseFormat;
    }
  ): Observable<HttpResponse<any>>;
  public getMappedServices(
    environmentId: string,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: apiResponseFormat;
    }
  ): Observable<HttpEvent<any>>;
  getMappedServices(
    environmentId: string,
    observe: any = "body",
    reportProgress = false,
    options?: {
      httpHeaderAccept?: apiResponseFormat;
    }
  ): Observable<any> {
    let headers = this.defaultHeaders;

    let httpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected?.startsWith("text")
    ) {
      responseType = "text";
    }
    return this.http.get<any>(
      `${this.authServerUrl}/api/app/environment/environment-details/${environmentId}`,
      {
        responseType: responseType as any,
        withCredentials: false,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

} 